export const messages = {
  en: {
    editOrg: {
      title: 'Edit Organization',
      orgName: 'Organization Name',
      orgNamePlaceholder: 'Please enter organization name',
      orgNameRequired: 'Organization name is required',
      orgNameLength: 'Organization name length should be between 2-50 characters',
      parentOrg: 'Parent Organization',
      parentOrgPlaceholder: 'Parent organization name',
      parentOrgRequired: 'Parent organization is required',
      description: 'Description',
      descriptionPlaceholder: 'Please enter organization description',
      descriptionLength: 'Description length cannot exceed 200 characters',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Organization updated successfully',
      updateFailed: 'Failed to update organization'
    }
  },
  zh: {
    editOrg: {
      title: '编辑组织',
      orgName: '组织名称',
      orgNamePlaceholder: '请输入组织名称',
      orgNameRequired: '组织名称不能为空',
      orgNameLength: '组织名称长度应在2-50个字符之间',
      parentOrg: '上级组织',
      parentOrgPlaceholder: '上级组织名称',
      parentOrgRequired: '上级组织不能为空',
      description: '描述',
      descriptionPlaceholder: '请输入组织描述',
      descriptionLength: '描述长度不能超过200个字符',
      cancel: '取消',
      save: '保存',
      saveSuccess: '组织更新成功',
      updateFailed: '组织更新失败'
    }
  }
} 